import { mutationTypes } from '@/core/constants'
import EstornarItemAdesaoInput from '@/core/apiclient/item-adesao/estorno/models/EstornarItemAdesaoInput'

export default {
	[mutationTypes.ADESAO.ITENS.ESTORNO.ESTORNAR.SET_FORM](state, { itensAdesao, quantidadeEstorno, justificativa }) {
		state.form = new EstornarItemAdesaoInput(itensAdesao, justificativa, quantidadeEstorno)
	},
	[mutationTypes.ADESAO.ITENS.ESTORNO.ESTORNAR.RESET_FORM](state) {
		state.form = new EstornarItemAdesaoInput()
	},
}
